"use client"

import classNames from "classnames"
import Image from "next/image"
import { useRouter } from "next/navigation"
import styles from "../../styles/LandingPage/Patients.module.scss"
import Button from "../components/Button/Button"
import { ModalState } from "../../pages/doctors"
import StyledText from "../typography/typography-component"
import skColors from "../../styles/skColors"
import { useTranslations } from "next-intl"

const svgFiles = [
  "/svg/partners/1_Bvdd.svg",
  "/svg/partners/2_DDC-Premium-Member-Badge.svg",
  "/svg/partners/3_Medical innovations.svg",
  "/svg/partners/5_Scale up 4 eu.svg",
  "/svg/partners/6_exist.svg",
  "/svg/partners/7_vhp.svg",
  "/svg/partners/8_sinc.svg",
  "/svg/partners/9_5-HT Chemistry-Health.svg",
  "/svg/partners/10_GCP.svg",
  "/svg/partners/11_Uni.svg",
  "/svg/partners/12_Zollhof.svg",
  "/svg/partners/13_HTGF.svg",
  "/svg/partners/14_starthaus logo.svg",
  "/svg/partners/15_De_hub.svg",
  "/svg/partners/16_Dr hoenle.svg",
]

const Network = ({ setIsModalOpen, style }: { setIsModalOpen; style?: React.CSSProperties }) => {
  const t = useTranslations("index")
  const router = useRouter()

  return (
    <div
      style={{
        height: "100%",
        ...style,
      }}
      className={classNames(styles.networkContainerDirection, styles.spaceAround, styles.itemsCenter, styles.flwr)}
    >
      <div className={classNames(styles.col, styles.marginRightBigScreen, styles.networkContent)}>
        <div>
          <StyledText variant={"h2"} color={skColors.turquoise[600]}>
            {t("network.title")}
          </StyledText>
        </div>

        <div
          style={{
            maxWidth: "1120px",
          }}
          className={classNames(styles.adaptiveSectionElevenTextAlign)}
        >
          <StyledText variant={"pLarge"}>{t("network.description")}</StyledText>
        </div>
      </div>

      <div className={styles.partnerImageContainer}>
        {svgFiles.map((src, index) => (
          <div key={index} className={styles.imageWrapper}>
            <img src={src} alt={`Partner ${index + 1}`} />
          </div>
        ))}
      </div>

      <Button
        className={styles.partnerButtonPosition}
        onClick={() => {
          sessionStorage.setItem("openContact", "true")
          router.push("/#contact-form")
        }}
        hug
        variant={"primary"}
      >
        {t("network.cta")}
      </Button>
    </div>
  )
}

export default Network
